import React, { Component } from 'react';
import {Row, Col, Button, Spinner} from 'react-bootstrap';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {ClidReportGenerate, ClidReportDownload, resetReport, closeModalPopUp} from './ReportsActions';
import { connect } from 'react-redux';	
import ShowModalPopUp from '../ShowModalPopUp';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportVariance from './ReportVariance';
import {URL_API_VARIANCE_DETAILS_REPORT_GENERATE, URL_API_VARIANCE_DETAILS_REPORT_EXCEL} from '../apiHitFile';

 class varianceReport extends Component { 
	constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true
    }
   }
  componentDidMount(){    
    this.props.actioninventoryUserMapped()
    this.props.resetReport()
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  componentWillReceiveProps = (nextProps) => {
    if(!_.isEqual(this.props.reportData, nextProps.reportData)){
    this.remakeHeader(nextProps.reportData)
    }
  }
  remakeHeader = (data) =>{
    if(!_.isEmpty(data)){
      let retundata=_.cloneDeep(data.grandTotal)
      if(!_.isEmpty(retundata)){
        _.map(retundata, (obj) => {
          obj['msisdn']='Overall'
        })
        data.grandTotal = retundata
        this.setState({setreportData:data})      
      }     
    } else {
      this.setState({setreportData:data})   
    }
  }

  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName = []
    if(!_.isEmpty(selectedcenterName)){
        clientName = _.filter(selectedcenterName.userClients);
        clientName = _.uniqBy(clientName, 'inventoryClientId');
    }
    return clientName;
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
            processName = (selectedclientName.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
      }
    return processName;
  }
  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({GenerateReport:false})
    }
  }
  handleChangeStart = (date) => {
    //date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
   // const formattedDate = date.getDate()+'/'+[date.getMonth()+1]+'/'+date.getFullYear();
    this.setState({startDate: date});
    //date.setMinutes( date.getMinutes() + date.getTimezoneOffset() )
  }
  handleChangeEnd = (e) => {
    this.setState({endDate: e});
  }
  validateInput = () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate} = this.state
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedprocessName) &&
    !_.isEmpty(selectedclientName) && typeof startDate !== "undefined"){
      return true
    }
  } 
  generateReport = () => {
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate } = this.state
    let obj = {
       "region":selectedregionName.inventoryRegionName,
       "center":selectedcenterName.inventoryCenterName,
       "client":selectedclientName.inventoryClientName,
       "process":selectedprocessName.inventoryProcessName,
       "regionId":selectedregionName.inventoryRegionId,
       "centerId":selectedcenterName.inventoryCenterId,
       "clientId":selectedclientName.inventoryClientId,
       "processId":selectedprocessName.inventoryProcessId,
       "month":moment(startDate).format('MMM'),
       "year":moment(startDate).format('YYYY')
    }
    // console.log('input', input)
    // let obj = {
    //   "region":"India",
    //   "center":"Dehardun",
    //   "client":"VIL",
    //   "process":"Inbound",
    //   "startDate":"2019-07-01", 
    //   "endDate":"2019-07-16"
    //   }
    this.props.TokenValidation()    
    this.props.ClidReportGenerate(obj, URL_API_VARIANCE_DETAILS_REPORT_GENERATE)
    this.setState({GenerateReport:true})
    //this.setState({GenerateReport:true}, ()=>this.handleToggle())
  }
  downloadReport= () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate } = this.state
    let obj = {
       "region":selectedregionName.inventoryRegionName,
       "center":selectedcenterName.inventoryCenterName,
       "client":selectedclientName.inventoryClientName,
       "process":selectedprocessName.inventoryProcessName,
       "regionId":selectedregionName.inventoryRegionId,
       "centerId":selectedcenterName.inventoryCenterId,
       "clientId":selectedclientName.inventoryClientId,
       "processId":selectedprocessName.inventoryProcessId,
       "month":moment(startDate).format('MMM'),
        "year":moment(startDate).format('YYYY')
      }
    // console.log('input', input)
    //   let obj = {
    //     "region":"India",
    //     "center":"Dehardun",
    //     "client":"VIL",
    //     "process":"Inbound",
    //     "startDate":"2019-07-01", 
    //     "endDate":"2019-07-16"
    //     }
    this.props.TokenValidation()    
    this.props.ClidReportDownload(obj, URL_API_VARIANCE_DETAILS_REPORT_EXCEL, "VARIANCE_DETAIL_REPORT.xlsx")
  }
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
	render(){    
    const {GenerateReport, toggleA} = this.state; 
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }		
		return(
			<div  className={(style) ? 'user' : "userSmall"}>				
			{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
				falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
      {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}  
      <div>
      <h6 onClick={this.handleToggle} >
        {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>&nbsp;REPORT CRITERIA</b></h6>       
      <div className={toggleA ? '': 'assesmentHide'}>   
      <Row className="marginBottom">  
      <Col>
      <label><b>REGION NAME<span className="RedColoring"> *</span></b></label><br/>
      <Picky keepOpen={false}
        value={this.state.selectedregionName}
        options={this.regionNames()}
        onChange={this.handleSelect}
        open={false}
        valueKey="inventoryRegionName"
        labelKey="inventoryRegionName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={false}
        placeholder='Select Region'
        dropdownHeight={600}
      />
      </Col>
      <Col>
      <label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
      <Picky keepOpen={false}
        value={this.state.selectedcenterName}
        options={this.centerNames()}
        onChange={this.handleSelectCenter}
        open={false}
        valueKey="inventoryCenterName"
        labelKey="inventoryCenterName"
        multiple={false}
        includeSelectAll={true}
        includeFilter={false}
        placeholder='Select Center'
        dropdownHeight={600}
      />
      </Col>
      <Col>
      <label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
      <Picky keepOpen={false}
      value={this.state.selectedclientName}
      options={this.clientNames()}
      onChange={this.handleSelectClient}
      open={false}
      valueKey="inventoryClientName"
      labelKey="inventoryClientName"
      multiple={false}
      includeSelectAll={true}
      includeFilter={false}
      placeholder='Select Client'
      dropdownHeight={600}
    />
    </Col>
      <Col>
      <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
      <Picky keepOpen={false}
      value={this.state.selectedprocessName}
      options={this.processNames()}
      onChange={this.handleSelectProcess}
      open={false}
      valueKey="inventoryProcessName"
      labelKey="inventoryProcessName"
      multiple={false}
      includeSelectAll={true}
      includeFilter={false}
      placeholder='Select Process'
      dropdownHeight={600}
    />
     </Col>
     <Col>
          <label><b>DATE<span className="RedColoring"> *</span></b></label>
          <DatePicker
          selected={this.state.startDate}
          onChange={this.handleChangeStart}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          placeholderText="Select Month/Year"
          />
     </Col> 
     </Row> 
     </div> 
     <Button className='buttonwidth alignInline alignRight' disabled={!this.validateInput()}
      onClick={this.generateReport}>Generate Report</Button>&nbsp; 
     {((GenerateReport === true) && !_.isEmpty(this.state.setreportData) && !_.isEmpty(this.props.reportData.value)) ?
     <Button className='buttonwidth alignInline alignRight' onClick={this.downloadReport}>Download Report</Button>  : null}            
      {((GenerateReport === true) && !_.isEmpty(this.state.setreportData)) ?
      <div>
        <ReportVariance  reportData={this.state.setreportData} onScroll={this.handleScroll}/>
      </div>
      : null}
    </div>     
    </div>)
	}


}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,        
    inventory: state.UserReducer.inventoryMapped, 
    isPending: state.ReportsReducer.isPending,
    reportData: state.ReportsReducer.reportData, 
    showerror:  state.ReportsReducer.showerror, 
    errmessage:  state.ReportsReducer.errmessage, 
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  ClidReportGenerate: (a, b) => dispatch(ClidReportGenerate(a, b)),
  ClidReportDownload: (a, b, c) => dispatch(ClidReportDownload(a, b, c)),
  resetReport: () => dispatch(resetReport()),
  TokenValidation : () => dispatch(TokenValidation()),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  
})


export default connect(mapStateToProps, mapDispatchToProps)(varianceReport);